module.exports = __webpack_public_path__ + "assets/img/hn.658112c7.png";